import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ResponseHttpSuccess} from "library";
import {map,of} from "rxjs";
import {environment} from "projects/store/src/environments/environment";
import {AuthService} from "projects/store/src/app/services/api/v1/auth.service";
import { OTP_SERVICE_MESSAGES } from 'projects/store/src/app/constants/otp-service.constants';
import {OtpServiceType} from "projects/store/src/app/enums/otp-service-types.enum";


@Injectable({ providedIn: 'root' })
export class NotificationOtpService {

  url: string = environment.salesAPIURL;

  constructor(private http: HttpClient, private authService: AuthService) {}

  otpService: string[] = ["whatsapp","llamada", "sms"];
  otpServiceMessages = OTP_SERVICE_MESSAGES

  get() {
    return this.http.get(`${this.url}notification/otp-services`, this.authService.getHttpOptionsBearer())
    .pipe(
      map((resp: any) => {
        const values: string[] = resp.body.data;
        return values
          .map((val: string) => this.otpServiceMessages.find(msg => msg.value === val))
          .filter(Boolean);
      })
    );
  }

  getDetailOtp(value: string): { label: string, value: string, message: string } {
    const found = this.otpServiceMessages.find(m => m.value === value);
    if (!found) {
      throw new Error(`OTP service message not found for value: ${value}`);
    }
    return found;
  }

  uploadFormData(file: Blob, nombreArchivo: string, tipo: string) {
    const formData = new FormData();
    formData.append('file', file, nombreArchivo);
    formData.append('nombreArchivo', nombreArchivo);
    formData.append('tipo', tipo);
    const options: any = this.authService.getHttpOptionsBearer();
    options.headers = options.headers.delete('Content-Type');
    return this.http.post(`${this.url}archivo/form-data`, formData, options)
      .pipe(map((resp: any) => resp as ResponseHttpSuccess));
  }

  sendWhatsapp(phoneNumber: string, url: string) {
    const completedPhone = environment.global.country.phoneCountryCode + phoneNumber;
    return this.http.post(`${this.url}phone/${completedPhone}/send`, {otp_service: OtpServiceType.WHATSAPP, content: url}, this.authService.getHttpOptionsBearer())
      .pipe( map((resp: any) => resp as ResponseHttpSuccess) );
  }
}
